<template>
  <div class="apply-address-page">
    <div class="main-content">
      <div class="content">
        <van-cell-group class="cell-block">
          <van-field clearable maxlength=50 v-model='ApplyForm.Recipient' name="recipient" v-validate="rules.recipient" label="收件人" placeholder="输入收件人姓名" :error-message="errors.first('recipient')" input-align="right" required />
          <van-field clearable maxlength=11 v-model='ApplyForm.ReceivePhone' name="receivePhone" v-validate="rules.receivePhone" label="收件手机" placeholder="输入收件人手机" :error-message="errors.first('receivePhone')" input-align="right" required />
          <van-field required v-model='showAreaText' name="provinceArea" v-validate="rules.provinceArea" label="所在地区" placeholder="选择收件省市区" @click="clickArea" :error-message="errors.first('provinceArea')" input-align="right" required />
          <van-field clearable maxlength=500 type="textarea" rows="10" v-model='ApplyForm.FullAddress' name="fullAddress" v-validate="rules.fullAddress" label="详细地址" placeholder="输入详细收件地址" :error-message="errors.first('fullAddress')" input-align="right" required />
        </van-cell-group>
        <van-cell-group class="cell-block checkbox-cell">
          <van-checkbox v-model="checked" disabled></van-checkbox>
          <span @click='modalShow.explain=true'>同意《肌功能评估工具包借用说明》</span>
        </van-cell-group>
      </div>
      <div class="btns">
        <van-button type="info" round size='large' @click="submit" block>申请</van-button>
      </div>
    </div>
    <!--省市区-->
    <van-popup v-model="modalShow.area" position="bottom">
      <div class="select-area-wrap">
        <div class="btn">
          <a class="cancel" @click="closeModal('area')">取消</a>
          <a class="confirm" @click="confirmChoseAreaData">确定</a>
        </div>
        <div class="list-box">
          <van-picker class="area-list" :columns="optData.areaOpt.country" @change="getSubArea" :default-index="choseAreaKey.countryIndex" value-key="Name" />
          <van-picker class="area-list" :columns="optData.areaOpt.province" @change="getSubArea" :default-index="choseAreaKey.provinceIndex" value-key="Name" />
          <van-picker class="area-list" :columns="optData.areaOpt.city" @change="getSubArea" :default-index="choseAreaKey.cityIndex" value-key="Name" />
          <van-picker class="area-list" :columns="optData.areaOpt.area" @change="getSubArea" :default-index="choseAreaKey.areaIndex" value-key="Name" />
        </div>
      </div>
    </van-popup>
    <van-popup v-model="modalShow.explain" position="bottom">
      <div class="detail-wrap">
        <h1 class='header-title'>肌功能评估工具包借用说明</h1>
        <p>尊敬的医生：</p>
        <p>您好！</p>
        <p>感谢您选择正雅肌功能矫治产品，接下来，我们将一起重新定义儿牙矫治。</p>
        <p>为了更好地协助您评估患者肌功能问题，我公司在肌功能治疗相关产品（口面肌训版）中增加了肌功能评估工具包：包含测力仪1个、芽芽盾若干、唇舌测量尺。与我公司的合同在有效期内的机构，旗下医生均可以个人名义向正雅借用1个工具包，借用期限为一年（自确认借用之日开始计算）。若借用期限届满且合作合同续签，则根据合同期限相应延期。在借用期间，若物品损坏或丢失，正雅不再另行补发。</p>
        <p>点击确认即代表您已了解以上说明并申请借用肌功能评估工具包。</p>
        <p>2023年2月8日</p>
        <p>正雅齿科科技（上海）有限公司</p>
        <div class="btns">
          <van-button type="info" round size='large' @click="confirm">已充分了解并同意借用说明</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Toast, Dialog } from 'vant';
import Vericode from "@/components/member/vericode";
export default {
  components: {
    Vericode
  },
  data () {
    return {
      showAreaText: '',
      ApplyForm: {},
      modalShow: {
        area: false,
        explain: false,
      },
      rules: {
        recipient: { required: true },
        receivePhone: { required: true },
        provinceArea: { required: true },
        fullAddress: { required: true }
      },
      optData: {//选项数据
        areaOpt: {
          country: [],
          province: [],
          city: [],
          area: []
        },
      },
      choseAreaKey: {
        countryIndex: 0,
        provinceIndex: 0,
        cityIndex: 0,
        areaIndex: 0
      },
      areaName: {
        1: 'country',
        2: 'province',
        3: 'city',
        4: 'area'
      },
      areaTemp: false,
      showExplain: false,
      checked: false,
    }
  },
  mounted () {
    this.getArea(1, null, false)
    this.getDoctorReceiveAddress()
  },
  methods: {
    confirm () {
      this.checked = true
      this.modalShow.explain = false
    },
    getDoctorReceiveAddress () {
      let sendParams = {
        AppID: this.GLOBAL.AppID,
        Method: 'GetGetDoctorReceiveAddress',
      }
      this.$Request(sendParams).then(res => {
        this.ApplyForm.CountryID = res.CountryID
        this.ApplyForm.ProvinceID = res.ProvinceID
        this.ApplyForm.CityID = res.CityID
        this.ApplyForm.RegionID = res.RegionID
        this.ApplyForm.FullAddress = res.FullAddress
        this.showAreaText = `${res.CountryName}${res.ProvinceName}${res.CityName}${res.RegionName}`
      })
    },
    clickArea () {
      this.modalShow.area = true
    },
    //确定选择省市区
    confirmChoseAreaData () {
      let countryText = this.optData.areaOpt.country.length && this.optData.areaOpt.country[this.choseAreaKey.countryIndex].Name;
      let provinceText = this.optData.areaOpt.province.length && this.optData.areaOpt.province[this.choseAreaKey.provinceIndex].Name;
      let cityText = this.optData.areaOpt.city.length && this.optData.areaOpt.city[this.choseAreaKey.cityIndex].Name;
      let areaText = this.optData.areaOpt.area.length && this.optData.areaOpt.area[this.choseAreaKey.areaIndex].Name;
      areaText = (areaText == 0 ? '' : areaText);
      this.showAreaText = countryText + '' + provinceText + '' + cityText + '' + areaText;
      this.ApplyForm.CountryID = this.optData.areaOpt.country[this.choseAreaKey.countryIndex].AreaID
      this.ApplyForm.ProvinceID = this.optData.areaOpt.province[this.choseAreaKey.provinceIndex].AreaID
      this.ApplyForm.CityID = this.optData.areaOpt.city[this.choseAreaKey.cityIndex].AreaID
      //AreaID取最后一级,如果没有取上级
      if (this.optData.areaOpt.area[this.choseAreaKey.areaIndex]) {
        this.ApplyForm.RegionID = this.optData.areaOpt.area[this.choseAreaKey.areaIndex].AreaID;
      } else {
        this.ApplyForm.RegionID = this.optData.areaOpt.city[this.choseAreaKey.cityIndex].AreaID;
      }
      this.closeModal('area');
    },
    //关闭选项弹窗
    closeModal (field) {
      this.modalShow[field] = false;
    },
    //获取地区
    getArea (type, AreaID) {
      let subType = type;
      let areaId = AreaID;
      if (subType > 4) {
        return;
      }
      let sendParams = {
        AppID: this.GLOBAL.AppID,
        Method: 'GetAreas',
        AreaID: areaId || '',//地区编号
        Type: type,//地区分类:1:国家,2:省/州,3:市,4:县/区 
      }
      this.$Request(sendParams).then(res => {
        if (res.AreaItems && res.AreaItems.length) {
          if (this.ApplyForm && this.areaTemp) {
            this.optData.areaOpt[this.areaName[type]] = res.AreaItems;
            this.optData.areaOpt[this.areaName[type]].map((item, index) => {
              if (type === 1 && (item.AreaID === this.CountryID)) {
                this.choseAreaKey.countryIndex = index;
                areaId = this.optData.areaOpt[this.areaName[type]][index].AreaID;
              }
              if (type === 2 && (item.AreaID === this.ProvinceID)) {
                this.choseAreaKey.provinceIndex = index;
                areaId = this.optData.areaOpt[this.areaName[type]][index].AreaID;
              }
              if (type === 3 && (item.AreaID === this.CityID)) {
                this.choseAreaKey.cityIndex = index;
                areaId = this.optData.areaOpt[this.areaName[type]][index].AreaID;
              }
              if (type === 4 && (item.AreaID === this.RegionID)) {
                this.choseAreaKey.areaIndex = index;
                areaId = this.optData.areaOpt[this.areaName[type]][index].AreaID;
              }
            })
            subType = type + 1;
            this.getArea(subType, areaId);
            subType++;
          } else {
            this.optData.areaOpt[this.areaName[type]] = res.AreaItems;
            areaId = this.optData.areaOpt[this.areaName[type]][0].AreaID;
            subType = type + 1;
            this.getArea(subType, areaId);
            subType++;
          }
        } else {
          this.optData.areaOpt[this.areaName[type]] = [];
        }
      })
    },
    getSubArea (picker, value, index) {
      this.areaTemp = false;
      let subLevel = parseInt(value.Type) + 1;
      let AreaID = value.AreaID;
      if (value.Type == 1) {
        this.choseAreaKey.provinceIndex = 0;
        this.choseAreaKey.cityIndex = 0;
        this.choseAreaKey.areaIndex = 0;
        this.choseAreaKey.countryIndex = index;
      } else if (value.Type == 2) {
        this.choseAreaKey.cityIndex = 0;
        this.choseAreaKey.areaIndex = 0;
        this.choseAreaKey.provinceIndex = index;
      } else if (value.Type == 3) {
        this.choseAreaKey.areaIndex = 0;
        this.choseAreaKey.cityIndex = index;
      } else if (value.Type == 4) {
        this.choseAreaKey.areaIndex = index;
      }
      this.getArea(subLevel, AreaID);
    },
    //提交
    submit () {
      if (!this.checked) {
        this.modalShow.explain = true
        return false
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          Toast.loading({
            duration: 0,
            message: '数据提交中...',
            overlay: true
          });
          this.$Request({
            AppID: this.GLOBAL.AppID,
            Method: 'SubmitMuscleFunctionApply',
            Recipient: this.ApplyForm.Recipient,//收件人
            ReceivePhone: this.ApplyForm.ReceivePhone,//收件电话
            CountryID: this.ApplyForm.CountryID,//国家编号
            ProvinceID: this.ApplyForm.ProvinceID,//省份编号
            CityID: this.ApplyForm.CityID,//城市编号
            RegionID: this.ApplyForm.RegionID,//区编号
            FullAddress: this.ApplyForm.FullAddress,//详细地址 
          }).then(res => {
            Toast.clear();
            Toast.success({
              message: '提交成功',
              duration: 300,
              onClose: () => {
                this.$router.push({ path: '/member-center', replace: true })
              }
            })
          }).catch(e => {
          })
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.apply-address-page {
  font-size: 28px;
  color: @hGray;
  /deep/.van-field__error-message {
    text-align: right;
  }
  .red {
    color: @red;
  }
  .content {
    padding: 30px;
    h1 {
      font-size: 32px;
      color: @hGray;
      text-align: center;
      margin-bottom: 40px;
    }
    .tip {
      color: @mGray;
      margin-bottom: 20px;
    }
    .row label {
      color: @mGray;
    }
    .delivery {
      margin-top: 20px;
      .yellow {
        color: #ff976a;
        font-size: 32px;
        line-height: 1.5;
      }
    }
  }
  .btns {
    width: 80%;
    margin: 40px auto;
  }
  .note {
    margin-top: 10px;
  }
  .checkbox-cell {
    display: flex;
    padding: 20px 0;
    span {
      margin-left: 10px;
      color: @blue;
    }
  }
  .select-area-wrap {
    .btn {
      display: flex;
      justify-content: space-between;
      padding: 20px;
      border-bottom: 1px solid #eeeeee;
      a {
        color: @blue;
      }
    }
    .list-box {
      display: flex;
      justify-content: space-around;
      padding-bottom: 20px;
    }
    .area-list {
      width: 25%;
    }
  }
  .detail-wrap {
    padding: 20px;
    .btn {
      display: flex;
      justify-content: space-between;
      padding: 20px;
      border-bottom: 1px solid #eeeeee;
      a {
        color: @blue;
      }
    }
    .header-title {
      font-size: 36px;
      line-height: 2;
      color: #000;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/member/apply-muscle.vue